import { createTheme } from "@mui/material/styles";

// Minimal MUI theme - most styling now comes from the target site's CSS files.
// MUI is kept only for complex components (modals, date pickers, data grid, etc.)
const theme = createTheme({
  palette: {
    primary: {
      main: "#0088CC",
    },
    secondary: {
      main: "#2C3E50",
    },
  },
  typography: {
    fontFamily: "Roboto Condensed, sans-serif",
  },
});

export default theme;
